import { useQueries } from "@tanstack/react-query";

import { type GetOrderbookResponse } from "#/types/api";

import { fetchOrderBook } from "../kyan.service";

export const useOrderbook = (instrumentNames: string[]) => {
  const queries = useQueries({
    queries: instrumentNames.map((instrumentName) => ({
      queryKey: ["fetchOrderbook", instrumentName],
      queryFn: () => fetchOrderBook({ instrument_name: instrumentName }),
      refetchInterval: 30_000,
    })),
  });

  const isLoading = queries.some((query) => query.isLoading);
  const data: GetOrderbookResponse[] = queries
    .map((query) => query.data?.data)
    .filter(
      (item): item is GetOrderbookResponse =>
        item !== null && item !== undefined,
    );

  const refetch = () => Promise.all(queries.map((query) => query.refetch()));

  return {
    data,
    isLoading,
    refetch,
  };
};
